import {
  ConfigNotificationPreferences,
  CustomerNotificationPrefsCreate,
  NotificationArea,
  NotificationChannel,
} from '@open-tender/types'

export const defaultCommsPrefs: CustomerNotificationPrefsCreate = []

export type NotificationPrefsLookup = Record<
  NotificationArea,
  NotificationChannel[]
>

export type DescriptionLookup = Record<
  `${NotificationArea}_${NotificationChannel}`,
  string
>

export const makeNotificationPrefs = (
  notificationPrefs?: ConfigNotificationPreferences
) => {
  if (!notificationPrefs) return { ORDER: [], MARKETING: [], RATING: [] }
  return notificationPrefs.reduce((obj, i) => {
    const existing = obj[i.notification_area] || []
    const updated = [...existing, i.notification_channel]
    return { ...obj, [i.notification_area]: updated }
  }, {} as NotificationPrefsLookup)
}

export const defaultDescriptionLookup = {
  ORDER_EMAIL: "Get my orders updates by email as it's being prepared",
  ORDER_SMS: "Get my orders updates by SMS as it's being prepared",
  ORDER_PUSH:
    "Get real-time push notifications on my orders as it's being prepared",
  ORDER_ALL: 'Get my orders updates through all available channels',
  MARKETING_EMAIL:
    'Get marketing emails about new products, promotions, and more',
  MARKETING_SMS: 'Get marketing SMS about new products, promotions, and more',
  MARKETING_PUSH: 'Get real-time push notifications on marketing updates',
  MARKETING_ALL: 'Get marketing updates through all available channels',
  RATING_EMAIL: 'Send me emails to rate and review my orders',
  RATING_SMS: 'Send me SMS to rate and review my orders',
  RATING_PUSH: 'Send me push notifications to rate and review my orders',
  RATING_ALL: 'Send me rating requests through all available channels',
}
